import React from 'react';
import { PasswordInput } from '@fiverr-private/identification_core';
import { translate } from '../../../utils/translate';
import { FieldName } from './EmailIdentificationStep.schema';

interface Props {
    isSignUpMode: boolean;
    passwordServerError: boolean;
}

export const PasswordField: React.FC<Props> = ({ isSignUpMode, passwordServerError }) => {
    const id = `identification-${FieldName.password}`;

    return (
        <PasswordInput
            id={id}
            name={FieldName.password}
            label={translate('steps.email_identification.password')}
            labelColor="grey_1200"
            autoComplete="current-password"
            hideError={isSignUpMode || !passwordServerError}
        />
    );
};
